export default __webpack_public_path__ + "static/media/icon-sort.ee46ea33.svg";